import max from 'lodash/max';
import { getAvailableSlots } from 'redux/modules/slots/selectors';

export const getMaxSlotCharge = (state: WtrState) => {
  const availableSlots = getAvailableSlots(state) || [];
  return max(availableSlots.map(slot => slot?.charge?.amount));
};
